import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberQuery } from '@fgb/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
class PortalIdComponent {
    constructor(memberQuery) {
        this.memberQuery = memberQuery;
    }
    ngOnInit() {
        this.portalId = this.memberQuery.getPortalId();
    }
}
PortalIdComponent.ɵfac = function PortalIdComponent_Factory(t) { return new (t || PortalIdComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery)); };
PortalIdComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PortalIdComponent, selectors: [["fgbcl-portal-id"]], decls: 1, vars: 1, template: function PortalIdComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate1("", ctx.portalId, "\n");
    } }, styles: [""] });
PortalIdComponent.ctorParameters = () => [
    { type: MemberQuery }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortalIdComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-portal-id',
                template: "{{ portalId }}\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.MemberQuery }]; }, null); })();

class PortalIdModule {
}
PortalIdModule.ɵfac = function PortalIdModule_Factory(t) { return new (t || PortalIdModule)(); };
PortalIdModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PortalIdModule });
PortalIdModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PortalIdModule, { declarations: function () { return [PortalIdComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PortalIdComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortalIdModule, [{
        type: NgModule,
        args: [{
                declarations: [PortalIdComponent],
                imports: [CommonModule],
                exports: [PortalIdComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PortalIdComponent, PortalIdModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-portal-id.js.map